module.exports = __webpack_public_path__ + "static/media/27540020_1964997823763980_6062082052073669612_n.4a407699.jpg";